import { Badge } from "@repo/ui/components/ui/badge";
import type { ReactNode } from "react";
import { StatusIcon, type StatusIconKind } from "@/shared/status/status-icon";
import type { AssessmentKind } from "../lib/assessment-detail-model";
import { AssessmentDetailBody } from "./assessment-detail-body";
import { AssessmentKindBadge } from "./assessment-kind-badge";
import { AssessmentScores } from "./assessment-scores";

export interface AssessmentDetailHeaderProps {
  title: string;
  kind: AssessmentKind;
  statusLabel: string;
  statusIcon: StatusIconKind;
  version: string;
  meta: string;
}

function AssessmentDetailLayout({ header, children }: { header: AssessmentDetailHeaderProps; children: ReactNode }) {
  return (
    <div className="flex min-h-0 flex-col">
      <Header {...header} />
      <div className="px-6 py-5">{children}</div>
    </div>
  );
}

function Header({ title, kind, statusLabel, statusIcon, version, meta }: AssessmentDetailHeaderProps) {
  return (
    <div className="space-y-1.5 border-b px-6 py-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
        <AssessmentKindBadge kind={kind} />
        <span className="flex items-center gap-1 text-sm text-muted-foreground">
          <StatusIcon status={statusIcon} size={14} className="shrink-0" />
          {statusLabel}
        </span>
        {version && (
          <Badge variant="outline" className="font-mono font-normal text-muted-foreground">
            v{version}
          </Badge>
        )}
      </div>
      <p className="text-sm text-muted-foreground">{meta}</p>
    </div>
  );
}

export const AssessmentDetail = Object.assign(AssessmentDetailLayout, {
  Scores: AssessmentScores,
  Body: AssessmentDetailBody,
});
